import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const UsersThreeIcon: React.FC<OneColorIconProps> = ({ size = 25, color = 'black', className }) => {
  const colorHex = getHexColor(color)
  return (
    <svg
      data-testid="users-three-icon"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 16.875C14.0711 16.875 15.75 15.1961 15.75 13.125C15.75 11.0539 14.0711 9.375 12 9.375C9.92893 9.375 8.25 11.0539 8.25 13.125C8.25 15.1961 9.92893 16.875 12 16.875Z"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.375 10.875C19.2484 10.8743 20.1098 11.0772 20.891 11.4677C21.6722 11.8583 22.3516 12.4256 22.8751 13.1246"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.12476 13.1248C1.64829 12.4257 2.32766 11.8584 3.10888 11.4678C3.89009 11.0772 4.75162 10.8743 5.62502 10.875"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.60327 20.2499C7.09595 19.238 7.8632 18.385 8.81747 17.7882C9.77173 17.1914 10.8745 16.875 12 16.875C13.1255 16.875 14.2284 17.1914 15.1826 17.7882C16.1369 18.3849 16.9041 19.238 17.3968 20.2499"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.62493 10.875C5.05572 10.8749 4.49828 10.7129 4.01771 10.4078C3.53714 10.1027 3.15328 9.66726 2.91095 9.1522C2.66861 8.63715 2.57781 8.06378 2.64914 7.49906C2.72047 6.93433 2.95099 6.40155 3.31378 5.96293C3.67658 5.52431 4.15667 5.19796 4.69799 5.02198C5.23932 4.84599 5.81954 4.82765 6.37091 4.96908C6.92227 5.11052 7.42202 5.40589 7.81179 5.82072C8.20157 6.23554 8.46529 6.7527 8.57215 7.31179"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4277 7.31183C15.5345 6.75265 15.7982 6.2354 16.188 5.82048C16.5778 5.40556 17.0776 5.11011 17.629 4.96862C18.1805 4.82713 18.7608 4.84545 19.3022 5.02143C19.8436 5.19742 20.3237 5.52381 20.6866 5.96248C21.0494 6.40116 21.28 6.93401 21.3513 7.49882C21.4226 8.06362 21.3318 8.63706 21.0894 9.15217C20.847 9.66728 20.4631 10.1028 19.9824 10.4079C19.5018 10.7129 18.9443 10.8749 18.375 10.875"
        stroke={colorHex}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
